import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import UsageAreas from './components/UsageAreas';
import Projects from './components/Projects';
import WhyUs from './components/WhyUs';
import TechnicalSpecs from './components/TechnicalSpecs';
import Pricing from './components/Pricing';
import LocalSEO from './components/LocalSEO';
import Blog from './components/Blog';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from '@/components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar transparent={true} />
      <Hero />
      <About />
      <Products />
      <UsageAreas />
      <Projects />
      <WhyUs />
      <TechnicalSpecs />
      <Pricing />
      <LocalSEO />
      <Blog />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
